const appSettings = {
    rootApiUrl: window._env_.API_URL,
    endPoints: {
        rating: '/rating/businessauto/Quote',
        zipCode: '/geodata/location',
        isoTerritory: '/rating/businessauto/isoterritory',
        excessLayerPremiumCalculation: '/dot/trucking/excessLayerPremium',
        dotScrapper: '/dot/trucking'
    }
};

module.exports = appSettings;